import frequencyPeriods from './frequencyPeriods';

const auTypes = [
  frequencyPeriods.WEEKLY,
  frequencyPeriods.FORTNIGHTLY,
  frequencyPeriods.MONTHLY,
];

export default auTypes;
